import { cacheDirectory, EncodingType } from '../../../utils/fileSystemCompat'
import React, { useEffect, useRef, useState } from 'react'
import { StyleSheet, Dimensions, TouchableOpacity, Text, Image, View, Linking, Alert } from 'react-native'
import { isAndroid } from '../../../utils/platformUtils'
import { useNavigation, useRoute } from '@react-navigation/native'
import { WebView } from 'react-native-webview'
import { ImageBackground } from 'react-native'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import styles from './WebViewScreenStyles'

import { openBrowserAsync } from 'expo-web-browser'
import { getConection, useButtonDownloadContext } from '../../appBar/context/HeaderContext'
import { searchFile } from './ImageWIthZoom'
import * as FileSystem from 'expo-file-system'
import * as IntentLauncher from 'expo-intent-launcher'

export const WebViewScreen = ({ route }) => {
    const { setLinkDownload, setIsLinkDownload } = useButtonDownloadContext()
    const navigation = useNavigation()
    const url = route.params.link
    const local = route.params.local
    const webViewRef = useRef()
    const generateRandomKey = () => parseInt(Math.random() * 100000, 10)
    const [isReloaded, setIsReloaded] = React.useState(false)
    const [base64Html, setBase64Html] = useState(null)
    const [loading, setLoading] = useState(true)

    const handleLoadStart = (event) => {
        const { nativeEvent } = event
    }

    useEffect(() => {
        setLinkDownload(url)
        setIsLinkDownload(true)
    }, [url])

    useEffect(() => {
        const unsubscribe = navigation.addListener('beforeRemove', (e) => {
            e.preventDefault()
            setLinkDownload('')
            setIsLinkDownload(false)
            navigation.dispatch(e.data.action)
        })

        return unsubscribe
    }, [navigation])

    const updateUriDrive = (url) => {
        const cleanUrl = (url || '').trim().replace(/["']/g, '')
        const lastDotIndex = cleanUrl.lastIndexOf('.')
        const ext = lastDotIndex !== -1 ? cleanUrl.slice(lastDotIndex).toLowerCase() : ''

        const isGoogleDriveViewer = cleanUrl.includes('drive.google.com/viewer')
        const extList = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']

        if (isGoogleDriveViewer || !extList.includes(ext)) {
            return url
        }

        let finalUrl = cleanUrl
        if (isAndroid() && extList.includes(ext)) {
            // url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${url}`
            finalUrl = `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(cleanUrl)}`
        }
        return finalUrl
    }

    return (
        <WebView
            key={generateRandomKey()}
            ref={webViewRef}
            source={{ uri: updateUriDrive(url) }}
            style={{ flex: 1 }}
            startInLoadingState={false}
            scalesPageToFit={true}
            allowFileAccess={true}
            allowUniversalAccessFromFileURLs={true}
            onLoadStart={(event) => handleLoadStart(event)}
            onLoadEnd={(data) => {
                const { url } = data.nativeEvent
                const { title } = data.nativeEvent

                if (url == null || (isAndroid() && title == '')) {
                    webViewRef.current?.reload()
                }
            }}
            onContentProcessDidTerminate={(data) => {}}
            originWhitelist={['*']}
            onError={(error) => {}}
            onMessage={(event) => {}}
        />
    )
}

export const WebViewButton = ({ url, preview, contentSeen, path }) => {
    const { languageFile } = getLanguage()
    const navigation = useNavigation()
    const { isConnected, hasInternet } = getConection()

    const goWebView = async (url) => {
        if (!url) {
            return
        }
        let { link, local } = await fetcWebViewLink(url, path)
        // contentSeen()
        if (isAndroid() && local && (!isConnected || !hasInternet)) {
            try {
                let cUri = await FileSystem.getContentUriAsync(link)
                let l2 = await IntentLauncher.startActivityAsync('android.intent.action.VIEW', {
                    data: cUri,
                    flags: 1,
                    type: 'application/pdf',
                })
                // Considerar el PDF como visto al abrirlo con la app nativa
                if (typeof contentSeen === 'function') {
                    try {
                        contentSeen()
                    } catch {}
                }
            } catch (e) {
                console.log('error', e)
            }
            return
        }

        if (!local && (!isConnected || !hasInternet)) {
            return Alert.alert('No puedes visualizar el contenido', 'Te encuentras sin conexión y no lo tienes descargado para modo offline.')
        }
        if (isAndroid()) {
            link = url
        }
        console.log('link', link)
        navigation.navigate('WebView', { link: link, local: local })
        setTimeout(() => {
            contentSeen()
        }, 3000)
    }

    return (
        <TouchableOpacity onPress={() => goWebView(url)}>
            {preview && preview !== '' ? (
                <Image source={{ uri: preview }} style={styles.img1} resizeMode='cover' />
            ) : (
                <ImageBackground source={require('../../../../assets/pdfpreview.png')} style={[styles.img2, { aspectRatio: 1 }]} resizeMode='cover'>
                    <View style={styles.containerText}>
                        <Text style={styles.text}>{languageFile.click_to_see}</Text>
                    </View>
                </ImageBackground>
            )}
        </TouchableOpacity>
    )
}

export const fetcWebViewLink = async (url, path) => {
    let local = false

    try {
        if (!path || path.trim() === '') {
            return { link: url, local: false }
        }

        let file = await searchFile(url, path)

        local = file.includes('http') ? false : true

        return { link: file, local: local }
    } catch {
        return { link: url, local: false }
    }
}

export const getWebViewUri = async (contentUri) => {
    const cacheUri = `${cacheDirectory}temp.pdf`

    await FileSystem.copyAsync({
        from: contentUri,
        to: cacheUri,
    })
    const info = await FileSystem.getInfoAsync(cacheUri)
    return cacheUri
}

export const loadPdfAsBase64 = async (filePath) => {
    const base64 = await FileSystem.readAsStringAsync(filePath, {
        encoding: 'base64',
    })

    const base64Uri = `data:application/pdf;base64,${base64}`
    return base64Uri
}
